import { getMartech } from 'ctm-util-functions/lib/get';
import { selectedProductIdSelector, verticalNameSelector } from '../../../base';

const resultsPayload = (impressions, state) => {
    const byPrice = (a, b) => (a.price > b.price ? 1 : -1);
    const withPosition = (xs) => xs.sort(byPrice).map((x, i) => ({ ...x, position: i + 1 }));
    return {
        currencyCode: 'AUD',
        impressions: withPosition(impressions)
    };
};

const moreInfoPayload = (impressions, state) => {
    const selectedId = selectedProductIdSelector(state);
    const selected = impressions.filter(({ id }) => id === selectedId);
    return {
        detail: {
            actionField: verticalNameSelector(state),
            products: selected
        },
        impressions: undefined
    };
};

const getCarEcommerce = (type, pageName, state) => {
    const getInState = getMartech(state);

    const results = getInState('vertical.quote.results.payload.results');

    if (!results) return {};

    const coverType = getInState('vertical.quote.results.config.helpers.filters.coverType') || 'COMPREHENSIVE';

    const getImpression = (result, i) => {
        const getInResult = getMartech(result);
        return ({
            name: getInResult('productMeta.name'),
            id: getInResult('productMeta.id'),
            price: getInResult('productMeta.price.annualPremium'),
            brand: getInResult('providerMeta.name'),
            category: coverType,
            variant: coverType,
            list: verticalNameSelector(state),
            position: i + 1
        });
    };

    const activeOnly = (result) => {
        const getInResult = getMartech(result);
        return getInResult('productMeta.available');
    };

    const impressions = results.toJS()[0].quotes
        .filter(activeOnly)
        .map(getImpression);

    switch (type) {
        case 'SET_RESULTS_PAYLOAD': {
            return { ecommerce: resultsPayload(impressions, state) };
        }
        case 'SET_ROUTER_LOCATION': {
            if (pageName === 'more_info') return { ecommerce: moreInfoPayload(impressions, state) };
            return {};
        }
        default: return {};
    }
};

export default getCarEcommerce;
